"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeContinuosMonths = exports.makeContinuosDays = exports.makeContinuosHours = exports.makeContinuos5Minutes = exports.makeContinuousTimeIntervals = exports.makeContinuous = exports.floorTimestampTo = exports.getMeasuredDate = void 0;
var getMeasuredDate = function (timezoneOffset) {
    if (timezoneOffset === void 0) { timezoneOffset = new Date().getTimezoneOffset(); }
    var d = new Date();
    d = new Date(d.getTime() + (timezoneOffset * -1) * 60 * 1000);
    return d.toISOString().slice(0, 19).replace('T', ' ');
};
exports.getMeasuredDate = getMeasuredDate;
// --------------------------------
// continuos date lists
// --------------------------------
var floorTimestampTo = function (timestamp, millis) {
    return Math.floor(timestamp / millis) * millis;
};
exports.floorTimestampTo = floorTimestampTo;
var makeContinuous = function (data, next, useData) {
    if (data.length <= 1)
        return data;
    var sortedData = data.sort(function (a, b) {
        return a.timestamp - b.timestamp;
    });
    var start = sortedData[0];
    var end = sortedData[data.length - 1].timestamp;
    var moment = start.timestamp;
    var result = [];
    result.push(start);
    var index = 1;
    do {
        moment = next(moment);
        if (moment >= end)
            break;
        var nextData = sortedData[index];
        if (!useData(moment, nextData.timestamp)) {
            result.push({
                timestamp: moment,
            });
        }
        else {
            result.push(nextData);
            index++;
        }
    } while (moment < end);
    result.push(sortedData[sortedData.length - 1]);
    return result;
};
exports.makeContinuous = makeContinuous;
var makeContinuousTimeIntervals = function (data, millisecondsBundle) {
    var rounded = data.map(function (d) {
        return __assign(__assign({}, d), { timestamp: (0, exports.floorTimestampTo)(d.timestamp, millisecondsBundle) });
    });
    return (0, exports.makeContinuous)(rounded, function (d) {
        return d + millisecondsBundle;
    }, function (moment, data) {
        return moment >= data;
    });
};
exports.makeContinuousTimeIntervals = makeContinuousTimeIntervals;
var makeContinuos5Minutes = function (data) {
    var minutes5 = 1000 * 60 * 5;
    return (0, exports.makeContinuousTimeIntervals)(data, minutes5);
};
exports.makeContinuos5Minutes = makeContinuos5Minutes;
var makeContinuosHours = function (data) {
    var hour = 1000 * 60 * 60;
    return (0, exports.makeContinuousTimeIntervals)(data, hour);
};
exports.makeContinuosHours = makeContinuosHours;
var makeContinuosDays = function (data) {
    var day = 1000 * 60 * 60 * 24;
    return (0, exports.makeContinuousTimeIntervals)(data, day);
};
exports.makeContinuosDays = makeContinuosDays;
var makeContinuosMonths = function (data) {
    return (0, exports.makeContinuous)(data, function (d) {
        var activeMonth = new Date(d);
        activeMonth.setMonth(activeMonth.getMonth() + 1);
        return activeMonth.getTime();
    }, function (moment, data) {
        var momentDate = new Date(moment);
        var dataDate = new Date(data);
        momentDate.setDate(1);
        momentDate.setHours(0);
        momentDate.setMinutes(0);
        momentDate.setSeconds(0);
        momentDate.setMilliseconds(0);
        dataDate.setDate(1);
        dataDate.setHours(0);
        dataDate.setMinutes(0);
        dataDate.setSeconds(0);
        dataDate.setMilliseconds(0);
        return momentDate.getTime() >= dataDate.getTime();
    });
};
exports.makeContinuosMonths = makeContinuosMonths;
